import React, { useEffect } from 'react';
import { useAppSelector as useSelector } from 'hooks/reduxHooks';
import { Route, RouteComponentProps, useHistory, useParams } from 'react-router-dom';

import * as AuthActions from 'store/auth/auth.action';
import useActions from 'hooks/useActions';
import { useFeatureFlag, useFeatureFlagsReady } from 'feature-flags';
import type { FeatureFlagKey } from 'feature-flags';

type TPrivateRouterProps = {
  exact: boolean;
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.FC<RouteComponentProps<any>> | React.FC<any>;
  requiredFlag?: FeatureFlagKey;
};

export default function PrivateRoute(props: TPrivateRouterProps) {
  const history = useHistory();
  const authActions = useActions(AuthActions);
  const auth = useSelector((state) => state.auth);
  const isReady = useFeatureFlagsReady();
  const { exact, path, component: RenderComponent, requiredFlag } = props;
  const hasFlag = useFeatureFlag(requiredFlag);
  const { pid: projectId } = useParams<{ pid: string }>();
  // authenticate user
  useEffect(() => {
    if (!auth?.authenticated) {
      authActions.authenticateUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // check if feature flag matches
  useEffect(() => {
    if (!isReady || !requiredFlag || hasFlag) return;
    history.push(`/project/${projectId}/no-access`);
  }, [hasFlag, requiredFlag, isReady, projectId, history]);

  return auth?.authenticated && isReady && (!requiredFlag || hasFlag) ? (
    <Route exact={exact} path={path} render={(props) => <RenderComponent {...props} />} />
  ) : (
    <></>
  );
}
